/* Lawazen Studio editor: text.
 * Arabic and English in the faces the site already loads. Size is in print-file
 * pixels (150 dpi on the tees), shown to the customer in centimetres of cap height. */
(function () {
  'use strict';
  var S = window.LZPW; if (!S) return;
  var el = S.el, t = S.t;

  S.on('ready', function () {
    S.ui.toolbar.appendChild(el('button', {
      type: 'button', class: 'lzpw-tool', 'data-tool': 'text',
      html: '<span aria-hidden="true" class="lzpw-tool-ico">T</span>' + t('add_text'),
      onclick: addText
    }));
  });

  function addText() {
    var p = S.placement(); if (!p) return;
    S.addLayer({
      kind: 'text', text: t('new_text'), font: S.lang === 'ar' ? 'Cairo' : 'Poppins',
      size: Math.round(p.filePx.h / 10), colour: '#111111', align: 'center', spacing: 0, bold: true,
      x: p.filePx.w / 2, y: p.filePx.h / 3, rot: 0
    });
    setTimeout(function () { var ta = S.ui.inspector.querySelector('textarea'); if (ta) { ta.focus(); ta.select(); } }, 0);
  }

  function cm(px) { var p = S.placement(); return (px / (p.dpi || 150) * 2.54).toFixed(1); }

  S.inspectors.text = function (box, l) {
    var first = true;
    function upd(fields, live) {
      if (live && first) { S.checkpoint(); first = false; }
      S.updateLayer(l.id, fields, !live);
    }
    function done() { first = true; }

    var ta = el('textarea', { class: 'lzpw-input', rows: '3', 'data-k': 'text', dir: 'auto' });
    ta.value = l.text;
    ta.addEventListener('input', function () { upd({ text: ta.value }, true); });
    ta.addEventListener('change', done);

    var font = el('select', { class: 'lzpw-select', 'data-k': 'font' });
    S.fonts.forEach(function (f) { font.appendChild(el('option', { value: f.family, text: f.label, selected: f.family === l.font, style: 'font-family:"' + f.family + '"' })); });
    font.addEventListener('change', function () { upd({ font: font.value }); });

    var size = el('input', { type: 'range', min: '20', max: '800', step: '1', 'data-k': 'size', class: 'lzpw-range' });
    size.value = l.size;
    var sizeOut = el('output', { class: 'lzpw-out' });
    size.addEventListener('input', function () { upd({ size: +size.value }, true); });
    size.addEventListener('change', done);

    var colour = el('input', { type: 'color', 'data-k': 'colour', class: 'lzpw-colour', value: l.colour });
    colour.addEventListener('input', function () { upd({ colour: colour.value }, true); });
    colour.addEventListener('change', done);

    var aligns = el('div', { class: 'lzpw-seg', role: 'group', 'aria-label': t('align') });
    ['left', 'center', 'right'].forEach(function (a) {
      aligns.appendChild(el('button', {
        type: 'button', class: 'lzpw-btn-s', 'data-align': a, 'aria-pressed': String((l.align || 'center') === a),
        text: t(a === 'center' ? 'centre' : a), onclick: function () { upd({ align: a }); }
      }));
    });
    var bold = el('button', { type: 'button', class: 'lzpw-btn-s', 'data-k': 'bold', 'aria-pressed': String(!!l.bold), html: '<b>B</b> ' + t('bold'),
      onclick: function () { upd({ bold: !S.layer(l.id).bold }); } });

    var spacing = el('input', { type: 'range', min: '-10', max: '60', step: '1', 'data-k': 'spacing', class: 'lzpw-range' });
    spacing.value = l.spacing || 0;
    spacing.addEventListener('input', function () { upd({ spacing: +spacing.value }, true); });
    spacing.addEventListener('change', done);

    function field(label, kids) { return el('div', { class: 'lzpw-field' }, [el('p', { class: 'lzpw-label', text: label })].concat(kids)); }
    box.appendChild(field(t('text'), [ta]));
    box.appendChild(field(t('font'), [font]));
    box.appendChild(field(t('size'), [el('div', { class: 'lzpw-row' }, [size, sizeOut])]));
    box.appendChild(el('div', { class: 'lzpw-row lzpw-row--split' }, [field(t('colour'), [colour]), field(t('align'), [aligns])]));
    box.appendChild(el('div', { class: 'lzpw-row lzpw-row--split' }, [field(t('spacing'), [spacing]), field(' ', [bold])]));
    S.inspectors.text.sync(box, l);
  };

  /* Keep the controls in step after undo, a drag on the stage, or a keyboard nudge. */
  S.inspectors.text.sync = function (box, l) {
    function set(k, v) { var n = box.querySelector('[data-k="' + k + '"]'); if (n && document.activeElement !== n && n.value !== String(v)) n.value = v; }
    set('text', l.text); set('font', l.font); set('size', Math.round(l.size)); set('colour', l.colour); set('spacing', l.spacing || 0);
    var out = box.querySelector('.lzpw-out'); if (out) out.textContent = cm(l.size * 0.7) + ' cm';
    Array.prototype.forEach.call(box.querySelectorAll('[data-align]'), function (b) { b.setAttribute('aria-pressed', String((l.align || 'center') === b.getAttribute('data-align'))); });
    var b = box.querySelector('[data-k="bold"]'); if (b) b.setAttribute('aria-pressed', String(!!l.bold));
  };
})();
